import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { AutorunComponent } from '@myshared/autorun.component';
import { Model } from '../../app.model';
import { CustomerService } from '../../customer/customer.service';
import { Customer } from '../../customer/customer.model';
import { CountryService } from '../../country/country.service';
import { CompanyService } from '../../company/company.service';
import { filterText } from '@myshared/utils';
import { action, observable } from '@myshared/mobx-connector';
import { MessageService } from 'primeng/api';
import { I18NextService } from 'angular-i18next';

@Component({
    selector: 'app-select-customer',
    templateUrl: './select-customer.component.html',
    standalone: false
})
export class SelectCustomerComponent extends AutorunComponent implements OnInit {

  public customers: Customer[];

  public multiselectableCustomer: { label: string; value: Customer }[] = [];
  public selectedCustomer: Customer;
  public isCreating = false;
  is20CSP: boolean;

  @observable private filter$: string;

  @Input() public stepsBack = 1;
  @Input() public reloadAfterCreated = true;
  @Input() public emitAfterCreated = true;
  @Input() public historyBack = true;

  @Output() public selected = new EventEmitter<Customer>();
  @Output() public back = new EventEmitter<void>();


  constructor(private m: Model,
    private customerService: CustomerService,
    private countryService: CountryService,
    private companyService: CompanyService,
    private messageService: MessageService,
    private i18next: I18NextService) {
    super();
  }

  ngOnInit() {
    this.doFilter('');

    this.autorun(() => {
      this.is20CSP = this.m.account.currentUser.companyIsPC20Csp;
      this.customers = filterText(this.m.customer.customers, this.filter$);
      if (this.customers[0]) {
        this.selectedCustomer = this.customers[0];
      }
      this.multiselectableCustomer = this.customers.map(c => {
        return {
          label: c.name,
          value: c
        }
      });

      this.isCreating = this.multiselectableCustomer.length <= 0;
    });

    this.countryService.refresh();
    this.companyService.refresh();
    this.customerService.refresh(true);
  }

  @action doFilter(value: string) {
    this.filter$ = value;
  }

  addCustomer(customer: Customer) {
    this.customerService.create(customer).subscribe(created => {
      if (this.reloadAfterCreated) {
        this.customerService.refresh(true);
      }
      if (this.emitAfterCreated) {
        this.selected.emit(created);
      } else {
        this.messageService.add({
          severity: 'success',
          summary: this.i18next.t('success') as string,
          detail: this.i18next.t('costumer_created', { name: created.name }) as string
        });
        this.selectedCustomer = created;
        this.next();
      }
    });
  }

  selectCustomer() {
    if (!this.selectedCustomer) return;
    this.next();
  }

  private next() {
    this.selected.emit(this.selectedCustomer);
  }

  /**
   * We need to check if this is a pascom one license workflow
   * of a classic annual workflow, because this view is for both
   */
  public get isOne() {
    return this.m.workflow.isOneTrial || this.m.workflow.isOneUpgrade;
  }

  public onAddCustomer() {
    this.isCreating = true;
  }

}
